import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FieldService {
  private visitorApiUrl = `${environment.baseUrl.replace('/v1/', '/api/v1/')}visitor-management/`;

  constructor(private http: HttpClient) {}

  listFieldsByRegister(registerId: number): Observable<any> {
    return this.http.get(`${this.visitorApiUrl}registers/${registerId}/fields/`);
  }

  listFields(registerId?: number): Observable<any> {
    let params = new HttpParams();
    if (registerId) {
      params = params.set('register_id', registerId.toString());
    }
    return this.http.get(`${this.visitorApiUrl}register-fields/`, { params });
  }

  createField(payload: any): Observable<any> {
    return this.http.post(`${this.visitorApiUrl}register-fields/`, payload);
  }

  updateField(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.visitorApiUrl}register-fields/${id}/`, payload);
  }

  deleteField(id: number): Observable<any> {
    return this.http.delete(`${this.visitorApiUrl}register-fields/${id}/`);
  }
}
